import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import SoftAvatar from "components/SoftAvatar";
import { ComponentListItemIcon, ComponentListItemButton } from "../StyledComponents";
import { THEME_COLORS } from "constants/theme";
import { COMMON_COMPONENT_TYPES } from "constants/flowDesigner";
import { useSelector } from "react-redux";

const styles = {
  componentMenuIcon: (theme) => ({
    color: THEME_COLORS[theme.palette.mode.toUpperCase()]?.PRIMARY_FONT
  })
};

const CommonComponentMenuItem = ({
  label,
  type,
  icon: IconComponent,
  onDragStart = Function(),
  onDragEnd = Function(),
  allowDescription,
  addStep = Function(),
  allowDragAndDrop = false,
  customStyles = {},
  allowEditWorkflow = false
}) => {
  const flipIconVertical = type === COMMON_COMPONENT_TYPES.SELECTION ? "fa-flip-vertical" : "";
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);

  const CommonComponentIcon = ({ icon: Icon }) => {
    return <Icon sx={(theme) => styles.componentMenuIcon(theme)} className={flipIconVertical} />;
  };

  if (allowDescription) {
    return (
      <ListItem sx={{ padding: "4px 20px 4px 5px" }} title={label}>
        <ComponentListItemButton
          role={undefined}
          onClick={() => addStep({ type, label })}
          dense
          sx={{ maxWidth: 300, paddingRight: 2 }}
          onDragStart={(event) =>
            onDragStart(event, "common", {
              label: label,
              type: type
            })
          }
          onDragEnd={onDragEnd}
          draggable={allowDragAndDrop || allowEditWorkflow}
          disabled={!allowEditWorkflow || !currentSavedFlow}
        >
          <ComponentListItemIcon sx={{ ...customStyles }}>
            <CommonComponentIcon icon={IconComponent} />
          </ComponentListItemIcon>
          <ListItemText
            primary={label}
            primaryTypographyProps={{
              sx: { fontSize: "13px", textOverflow: "ellipsis", overflow: "hidden" }
            }}
          />
        </ComponentListItemButton>
      </ListItem>
    );
  }

  return (
    <Tooltip key="arrow-rect" title={label}>
      <SoftAvatar
        size="xs"
        onDragStart={(event) =>
          onDragStart(event, "common", {
            label: label,
            type: type
          })
        }
        onDragEnd={onDragEnd}
        draggable
      >
        <CommonComponentIcon icon={IconComponent} />
      </SoftAvatar>
    </Tooltip>
  );
};

export default CommonComponentMenuItem;
